<template>
  <div v-if="sites.length > 0" class="site-cards">
    <span class="title">あわせて事前登録！</span>
    <span v-if="message" class="message" v-text="message" />
    <div class="card-container">
      <SiteCard
        v-for="site in sites"
        :key="site.id"
        :site="site"
        :value="checkedSiteIds.has(site.id)"
        @change="changed"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, Ref, computed, ref } from '@vue/composition-api';
import SiteCard, { Site } from './SiteCard.vue';

export default defineComponent({
  components: {
    SiteCard,
  },
  props: {
    initialCheckedSiteIds: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
  },
  setup(props) {
    const checkedSiteIds: Ref<Set<number>> = ref(new Set(props.initialCheckedSiteIds));
    const sites: Ref<Site[]> = ref([]);
    const setSites = (newSites: Site[]) => {
      sites.value = [...newSites];
    };

    const changed = ({ id, checked: newChecked }: { id: number; checked: boolean }) => {
      const newSet = new Set(checkedSiteIds.value);
      if (newChecked) {
        newSet.add(id);
      } else {
        newSet.delete(id);
      }
      checkedSiteIds.value = newSet;
    };

    const message = computed(() => {
      const unchecedCount = sites.value.filter((site) => !checkedSiteIds.value.has(site.id)).length;
      return unchecedCount > 0 ? `${unchecedCount}件が未選択です！` : undefined;
    });

    return {
      checkedSiteIds,
      sites,
      setSites,
      changed,
      message,
    };
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';

.site-cards {
  margin-bottom: 32px;
}

.card-container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: stretch;
  @include media-mobile {
    flex-direction: column;
  }
}

.title {
  color: $v2-main-color;
  font-size: 16px;
  font-weight: 700;
}

.message {
  margin-left: 8px;
  color: $v2-text-red;
  font-size: 16px;
  font-weight: 700;
}
</style>
